export const CLEAR_AD_CREATIVE = 'CLEAR_AD_CREATIVE'
export const CLEAR_AD_CREATIVES = 'CLEAR_AD_CREATIVES'
export const SET_AD_CREATIVE = 'SET_AD_CREATIVE'
export const SET_AD_CREATIVES = 'SET_AD_CREATIVES'
export const SET_AD_CREATIVE_COUNT = 'SET_AD_CREATIVE_COUNT'
export const SET_PENDING_AD_CREATIVE_COUNT = 'SET_PENDING_AD_CREATIVE_COUNT'
